
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifestyle/articles/[id]",
      function () {
        return require("private-next-pages/lifestyle/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifestyle/articles/[id]"])
      });
    }
  